var _rect, _rect2, _rect3, _rect4, _path, _rect5, _g, _rect6, _rect7, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHedgeBuys5Percent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 168,
    viewBox: "0 0 202 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.3003,
    y: 55.7903,
    width: 157.15,
    height: 73.2048,
    rx: 36.6024,
    transform: "rotate(-7.12795 21.3003 55.7903)",
    stroke: "#1FC086",
    strokeWidth: 4.827,
    strokeDasharray: "9.65 9.65"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.15133,
    y: 72.2524,
    width: 93.2301,
    height: 93.2301,
    rx: 46.6151,
    fill: "#004945"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.6143,
    y: 120.007,
    width: 13.5687,
    height: 33.0738,
    fill: "#EEFFFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8423,
    y: 84.3887,
    width: 13.5687,
    height: 68.6917,
    fill: "#EEFFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2386 118.889L24.5705 119.398V120.238V131.879V135.304L27.2946 133.228L49.9446 115.969L72.7331 133.231L75.4533 135.292V131.879V120.238V119.395L74.7813 118.886L50.9657 100.846L49.9385 100.067L48.9136 100.848L25.2386 118.889Z",
    fill: "#1FC086",
    stroke: "#004945",
    strokeWidth: 3.39219
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.15133,
    y: 72.2524,
    width: 93.2301,
    height: 93.2301,
    rx: 46.6151,
    stroke: "#004945",
    strokeWidth: 4.96492
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_303_505)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.101,
    y: 5,
    width: 88.2652,
    height: 88.2652,
    rx: 44.1326,
    fill: "#EEFFFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.74,
    cy: 32.8112,
    r: 11.3161,
    fill: "#004945",
    stroke: "#004945",
    strokeWidth: 4.52642
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_303_505",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.373 71.3532C175.373 71.3306 175.373 71.308 175.373 71.2854C175.373 58.7861 165.24 48.6533 152.741 48.6533C140.242 48.6533 130.109 58.7861 130.109 71.2854C130.109 71.2855 130.109 71.2857 130.109 71.2858H130.109V109.76H175.373V71.3532Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.373 71.3532C175.373 71.3306 175.373 71.308 175.373 71.2854C175.373 58.7861 165.24 48.6533 152.741 48.6533C140.242 48.6533 130.109 58.7861 130.109 71.2854C130.109 71.2855 130.109 71.2857 130.109 71.2858H130.109V109.76H175.373V71.3532Z",
    fill: "#004945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.373 71.3532L170.847 71.3401V71.3532H175.373ZM130.109 71.2858V75.8122H134.635V71.2858H130.109ZM130.109 71.2858V66.7594H125.582V71.2858H130.109ZM130.109 109.76H125.582V114.287H130.109V109.76ZM175.373 109.76V114.287H179.9V109.76H175.373ZM170.847 71.2854C170.847 71.3034 170.847 71.3217 170.847 71.3401L179.899 71.3662C179.9 71.3395 179.9 71.3126 179.9 71.2854H170.847ZM152.741 53.1797C162.741 53.1797 170.847 61.2859 170.847 71.2854H179.9C179.9 56.2862 167.74 44.1269 152.741 44.1269V53.1797ZM134.635 71.2854C134.635 61.2859 142.742 53.1797 152.741 53.1797V44.1269C137.742 44.1269 125.583 56.2862 125.583 71.2854H134.635ZM134.635 71.2858C134.635 71.2857 134.635 71.2856 134.635 71.2856C134.635 71.2855 134.635 71.2855 134.635 71.2854H125.583C125.583 71.2855 125.583 71.2856 125.583 71.2857C125.583 71.2857 125.583 71.2858 125.583 71.2858H134.635ZM130.109 75.8122H130.109V66.7594H130.109V75.8122ZM134.635 109.76V71.2858H125.582V109.76H134.635ZM175.373 105.234H130.109V114.287H175.373V105.234ZM170.847 71.3532V109.76H179.9V71.3532H170.847Z",
    fill: "#004945",
    mask: "url(#path-9-inside-1_303_505)"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 105.619,
    y: 2.51754,
    width: 93.2301,
    height: 93.2301,
    rx: 46.6151,
    stroke: "#004945",
    strokeWidth: 4.96492
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 75.3687,
    y: 56.2336,
    width: 48.9465,
    height: 51.1786,
    rx: 24.4733,
    fill: "#1FC086"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.601 73.0543V66.8937H100.704V73.0543H98.601ZM98.601 95.7781V89.3963H100.704V95.7781H98.601ZM99.5602 91.3145C98.2076 91.3145 96.9902 91.167 95.9081 90.8718C94.826 90.5767 93.9038 90.1709 93.1414 89.6545C92.379 89.1135 91.7888 88.474 91.3707 87.7362C90.9772 86.9985 90.7805 86.1623 90.7805 85.2278C90.7805 85.1294 90.7805 85.031 90.7805 84.9327C90.7805 84.8343 90.7928 84.7605 90.8174 84.7113H95.7606C95.7606 84.7605 95.7606 84.8097 95.7606 84.8589C95.7606 84.9081 95.7606 84.9572 95.7606 85.0064C95.7851 85.6213 95.9819 86.1254 96.3508 86.5189C96.7197 86.8878 97.1992 87.1583 97.7895 87.3305C98.4043 87.5026 99.0437 87.5887 99.7077 87.5887C100.298 87.5887 100.864 87.5395 101.405 87.4411C101.97 87.3182 102.438 87.1091 102.806 86.814C103.2 86.5189 103.397 86.1377 103.397 85.6704C103.397 85.0802 103.151 84.6252 102.659 84.3055C102.192 83.9858 101.564 83.7276 100.778 83.5309C100.015 83.3341 99.179 83.1128 98.269 82.8668C97.4329 82.6701 96.5967 82.4488 95.7606 82.2028C94.9244 81.9323 94.162 81.588 93.4734 81.1699C92.8094 80.7519 92.2684 80.2108 91.8503 79.5468C91.4322 78.8582 91.2232 77.9974 91.2232 76.9645C91.2232 75.9562 91.4445 75.0832 91.8872 74.3454C92.3298 73.583 92.9324 72.9559 93.6947 72.464C94.4817 71.9722 95.3917 71.6156 96.4246 71.3942C97.4821 71.1483 98.6133 71.0253 99.8184 71.0253C100.95 71.0253 102.007 71.1483 102.991 71.3942C103.975 71.6156 104.835 71.9599 105.573 72.4271C106.311 72.8698 106.889 73.4355 107.307 74.1241C107.725 74.7881 107.934 75.5381 107.934 76.3743C107.934 76.5465 107.934 76.7063 107.934 76.8539C107.934 77.0014 107.922 77.0998 107.897 77.149H102.991V76.8539C102.991 76.4112 102.856 76.0423 102.585 75.7472C102.315 75.4275 101.921 75.1816 101.405 75.0094C100.913 74.8373 100.31 74.7512 99.5971 74.7512C99.1052 74.7512 98.6502 74.7881 98.2321 74.8618C97.8387 74.9356 97.4944 75.0463 97.1992 75.1938C96.9041 75.3414 96.6705 75.5259 96.4983 75.7472C96.3508 75.9439 96.277 76.1899 96.277 76.485C96.277 76.9031 96.4492 77.2474 96.7935 77.5179C97.1624 77.7638 97.6419 77.9729 98.2321 78.145C98.8224 78.3172 99.4741 78.5016 100.187 78.6983C101.073 78.9443 101.995 79.1902 102.954 79.4361C103.938 79.6575 104.848 79.9649 105.684 80.3584C106.52 80.7519 107.196 81.3175 107.713 82.0553C108.229 82.7685 108.487 83.7399 108.487 84.9695C108.487 86.15 108.254 87.146 107.786 87.9576C107.344 88.7691 106.717 89.4209 105.905 89.9127C105.094 90.4046 104.147 90.7612 103.065 90.9825C101.983 91.2039 100.814 91.3145 99.5602 91.3145Z",
    fill: "#EEFFFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_303_505"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.101,
    y: 5,
    width: 88.2652,
    height: 88.2652,
    rx: 44.1326,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHedgeBuys5Percent);
export default __webpack_public_path__ + "static/media/HedgeBuys5Percent.0e3b75d7f66ec568190b80ebb85dc474.svg";
export { ForwardRef as ReactComponent };